import { useCallback } from 'react'
import { StoredIndividualization } from '../types/Individualization'
import { api, ApiRoutes } from '../services/ApiService'

export const useToggleVisibility = () => {
    const handleToggle = useCallback((element: StoredIndividualization) => {
        return api.post(ApiRoutes.INDIVIDUALIZATION_TOGGLE, element.id, {
            active: !element.active,
        })
    }, [])

    return {
        toggle: handleToggle,
    }
}
